<!--Load the font icons package:-->
<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<!-- <form [formGroup]="form" (ngSubmit)="onSaveAction()" class="k-form-inline"> -->
<form [formGroup]="permissionForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="entity">Entity</label>
    <div class="col-8">
      <input type="text" id="entity" formControlName="entity" class="form-control" appAutoFocus>
      <div *ngIf="entity?.invalid" class="alert alert-danger">
        <div *ngIf="entity?.errors?.['required']">Entity is required.</div>
      </div>
    </div>
  </div>

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="action">Action</label>
    <div class="col-8">
      <input type="text" id="action" formControlName="action" class="form-control">
      <div *ngIf="action?.invalid" class="alert alert-danger">
        <div *ngIf="action?.errors?.['required']">Action is required.</div>
      </div>
    </div>
  </div>

</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="permissionForm.invalid">
    Save
  </button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
